import types from './action-types';

const service = abp.services.api.axisCoordinateService;

const axisCoordinatesActions = {
    refreshData: function () {
        return (dispatch, getState) => {
            var axisId = getState().axisCharts.axisId;

            loadDataInternal(axisId, dispatch);
        }
    },
    loadData: function (axisId) {
        return (dispatch, getState) => {
            loadDataInternal(axisId, dispatch);
        }
    }
}

function loadDataInternal(axisId, dispatch) {
    dispatch({ type: types.LOADING, axisId });

    service.getAll(axisId)
        .done(function (result) {
            dispatch({
                type: types.COORDINATES_LOADED,
                coordinates: result
            });
        });
}

export default axisCoordinatesActions;


// WEBPACK FOOTER //
// ./App/components/modules/charts/actions.js